const getElementWithInlineStyles = (element) => {
    const computedStyle = window.getComputedStyle(element);
    let styleString = "";
    for (let i = 0; i < computedStyle.length; i++) {
        const prop = computedStyle[i];
        const value = computedStyle.getPropertyValue(prop);
        styleString += `${prop}: ${value}; `;
    }
    // Clone element to not mutate the original
    const clone = element.cloneNode(true);
    clone.setAttribute("style", styleString);

    // Recursively inline children styles too
    function inlineChildrenStyles(el, cloneEl) {
        for (let i = 0; i < el.children.length; i++) {
            const child = el.children[i];
            const cloneChild = cloneEl.children[i];
            const childStyle = window.getComputedStyle(child);
            let childStyleString = "";
            for (let j = 0; j < childStyle.length; j++) {
                const prop = childStyle[j];
                const value = childStyle.getPropertyValue(prop);
                childStyleString += `${prop}: ${value}; `;
            }
            cloneChild.setAttribute("style", childStyleString);
            if (child.children.length > 0) {
                inlineChildrenStyles(child, cloneChild);
            }
        }
    }

    inlineChildrenStyles(element, clone);

    return clone.outerHTML;
}

export { getElementWithInlineStyles }
